// extracted by mini-css-extract-plugin
module.exports =  {"channel-column":"channel-column-bktuA","inner":"inner-ElVwH","cell":"cell-NjrK6","skeleton":"skeleton-oo546","shimmer":"shimmer-MC0ce"};